module.exports = __webpack_public_path__ + "static/media/High_Street_Pheonix.57d3c8f4.png";